import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        fees: [
          !_.isNil(entity?.parameters?.fees)
            ? entity.parameters.fees * 100
            : null,
          Validators.required,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    const formValue = _.cloneDeep(this.form?.value?.products);
    formValue?.forEach(item => {
      item.parameters.fees = !_.isNil(item.parameters.fees)
        ? item.parameters.fees / 100
        : null;
    });
    return formValue;
  }
}
